import {Component} from '@angular/core';
import {IHeaderAngularComp} from 'ag-grid-angular';
import {IHeaderParams} from 'ag-grid-community';
import {DateTime} from 'luxon';
import {JumpToDatePickerCalendarComponent} from './jump-to-date-picker-calendar.component';
import {JumpToDatePickerHeaderParams} from './jump-to-date-picker-header-params.interface';

@Component({
  templateUrl: './jump-to-date-picker-header.component.html',
  styleUrl: './jump-to-date-picker-header.component.scss'
})
export class JumpToDatePickerHeaderComponent implements IHeaderAngularComp {
  public selectedDate: DateTime;
  private onSelectedDateChanged: (date: DateTime) => any;
  public readonly JUMP_TO_DATE_PICKER_CALENDAR = JumpToDatePickerCalendarComponent;

  public agInit(params: JumpToDatePickerHeaderParams): void {
    this.selectedDate = params.selectedDate;
    this.onSelectedDateChanged = params.onSelectedDateChanged;
  }

  public selectedDateChanged(date: DateTime): void {
    this.selectedDate = date;
    this.onSelectedDateChanged(date);
  }

  public refresh(params: IHeaderParams): boolean {
    return false;
  }
}
